import * as Fullscreen from "./Control.FullScreen.js";
import * as Locate from "./L.Control.Locate.min.js";

export default async function (placesUrl) {

  const res = await fetch(placesUrl);
  const places = await res.json();

  var map = L.map("map", {
    zoomControl: false,
    zoomSnap: 0.5
  });

  const gps = L.control.locate({
    position: "topright"
  }).addTo(map)
  // L.control.defaultExtent()
  // .addTo(map);
  // const bookmarks = new L.Control.Bookmarks().addTo(map);

  mapToggleInteraction(map, false)

  const view = [
    [41, -98], 4.8
  ];

  map.setView(view[0], view[1]);

  var bright = L.tileLayer('https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png', {
    minZoom: 0,
    maxZoom: 20,
    attribution: '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
  })

  var outdoors = L.tileLayer('https://tiles.stadiamaps.com/tiles/outdoors/{z}/{x}/{y}{r}.png', {
    maxZoom: 20,
    attribution: '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
  });

  var toner = L.tileLayer('https://stamen-tiles-{s}.a.ssl.fastly.net/toner/{z}/{x}/{y}{r}.{ext}', {
    attribution: 'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    subdomains: 'abcd',
    minZoom: 0,
    maxZoom: 20,
    ext: 'png'
  })

  var esri = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}', {
    attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community'
  });

  var csb = L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
    subdomains: 'abcd',
    maxNativeZoom: 19,
    maxZoom: 22
  });

  var atlas = L.tileLayer('https://{s}.tile.thunderforest.com/mobile-atlas/{z}/{x}/{y}.png?apikey={apikey}', {
    attribution: '&copy; <a href="http://www.thunderforest.com/">Thunderforest</a>, &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    apikey: 'b63bb82b281545789f2795d3fe771580',
    maxZoom: 22
  });

  var sunny = L.tileLayer('https://{s}.tile.jawg.io/jawg-sunny/{z}/{x}/{y}{r}.png?access-token=ma9bjS3Q81v5uh5EYIGBEyblVIQ7WjECYQfdMafQHkyWQWU6YX3KrcnoOmExpID2', {
    attribution: '<a href="http://jawg.io" title="Tiles Courtesy of Jawg Maps" target="_blank">&copy; <b>Jawg</b>Maps</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    minZoom: 0,
    maxZoom: 22,
    subdomains: 'abcd',
    accessToken: 'ma9bjS3Q81v5uh5EYIGBEyblVIQ7WjECYQfdMafQHkyWQWU6YX3KrcnoOmExpID2'
  });

  sunny.addTo(map)
  // toner.addTo(map)

  var markerOptions = {
    icon: "star",
    iconShape: 'circle',
    borderColor: "black",
    textColor: "red",

    iconSize: [36, 36],
    popupAnchor: [7, -10],
    innerIconStyle: "font-size: 28px"
  };

  L.marker([44.089188, -69.396187], {
      icon: L.BeautifyIcon.icon(markerOptions),
      draggable: false
    }).addTo(map)
    .bindPopup("<a href='https://www.topslfarm.com/'>Tops'l Farm</a><br><a href='https://www.google.com/maps/dir/Current+Location/44.089188,-69.396187'>Directions</a>")

  const points = [
    [39.6872537002828, -82.6029396057129],
    [41.85337224935614, -87.95242309570314],
    [39.1414008478314, -84.37585830688478],
    // [44.256187,-69.093312],
    [40.727688, -73.797188],
    [40.825812, -74.208188],
    [47.604062, -122.331563],
    [40.758688, -111.891312],
    [33.353188, -111.789438],
    [32.711438, -117.159937],
    [41.496938, -81.694563],
    [38.903437, -77.037688]

  ]

  points.forEach(p => {
    L.marker(p, {
      icon: L.BeautifyIcon.icon({
        icon: "map-pin",
        iconAnchor: [11, 22],
        iconShape: 'circle',
        borderColor: "transparent",
        backgroundColor: "transparent",
        textColor: "red",
        innerIconStyle: "font-size: 20px;transform: rotate(-25deg)"
      }),
      draggable: false
    }).addTo(map)
  })

  function fullScreenMap(e) {
    document.querySelector("#map-background").style.display = "none"

    // map.removeLayer(toner);
    // map.addLayer(bright);
    // map.addLayer(bright)
    mapToggleInteraction(map, true)
    Fullscreen.toggle(document.querySelector("#map"));
    map.flyTo([44.096356, -69.375727], 9);
    places.forEach(p => {
      if (p.coords) {
        L.marker([Number(p.coords.split(",")[0]), Number(p.coords.split(",")[1])], {
            icon: L.BeautifyIcon.icon({
              placeMarker: true,
              icon: (p.icon === "utencils") ? "cutlery" : (p.icon === "landmark") ? "university" : p.icon,
              // icon: p.icon,
              // iconSize: [30,30],
              // prefix: "fas",
              iconShape: 'marker',
              borderColor: "black",
              backgroundColor: "white",
              textColor: "blue",
              innerIconStyle: "font-size: 12px;"
            }),
            draggable: false
          })
          .addTo(map)
          //todo add popup template
          .bindPopup(`
          ${(p.url) ? '<a href="' + p.url + '">' : ''}<h5 style="text-align:left;margin-left:0;margin-bottom:0;">${p.name}</h5>${(p.url) ? '</a>' : ''}${(p.address) ? p.address.split(",")[0] + "<br>" + p.address.split(",")[1] + '&nbsp' + p.address.split(",")[2] : ""}
          <br><br>${p.about}
          <br><br>
          <a href='https://www.google.com/maps/dir/Current+Location/${p.name}/${Number(p.coords.split(",")[0])},${Number(p.coords.split(",")[1])}' target="_blank">Directions</a>`)
      }
    })

  }

  map.once("click", fullScreenMap)

  window.addEventListener("fullscreenchange", function (e) {
    if (document.fullscreenElement) {

    } else {
      document.querySelector("#map-background").style.display = "block"
      // map.removeLayer(bright);
      // map.addLayer(toner);
      mapToggleInteraction(map, false)
      map.once("click", fullScreenMap)
      map.setView(view[0], view[1]);
      map.eachLayer((layer) => {
        if (layer.options && layer.options.icon && layer.options.icon.options.placeMarker) layer.remove();
      });
    }
  })

  // bindPopup("popup").bindPopup("Waldoboro, ME");

  return map
}


function mapToggleInteraction(map, boolean) {
  if (boolean) {
    map.scrollWheelZoom.enable()
    map.dragging.enable()
    map.touchZoom.enable()
    map.doubleClickZoom.enable()
    map.boxZoom.enable()
    map.keyboard.enable()
    if (map.tap) map.tap.enable()
  } else {
    map.scrollWheelZoom.disable()
    map.dragging.disable()
    map.touchZoom.disable()
    map.doubleClickZoom.disable()
    map.boxZoom.disable()
    map.keyboard.disable()
    if (map.tap) map.tap.disable()

  }
}